import { getHasAbility } from 'conversations/modules/user/selectors'
import specifiedArraySort from 'conversations/utils/sortingUtils'
import { createSelector } from 'reselect'
import {
  FETCH_SECTIONS_FAIL,
  FETCH_SECTIONS_REQUEST,
  FETCH_SECTIONS_SUBSCRIPTIONS_FAIL,
  FETCH_SECTIONS_SUBSCRIPTIONS_REQUEST,
} from 'shared/store/actions/user/sections/constants'
import {
  ConversationSidebarSectionConfig,
  SectionNotificationSetting,
  SidebarSectionDetailModal,
} from 'shared/typings/conversationsSidebar/Filters'

import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.user

export const getHasConversationSections = (state: RootState): boolean =>
  getHasAbility('hasConversationSections')(state)

const EMPTY_OBJECT = {}
export const getAllConversationSections = (
  state: RootState
): Record<string, ConversationSidebarSectionConfig> =>
  root(state).conversationSections ?? EMPTY_OBJECT

export const getFilteredConversationSections = createSelector(
  getAllConversationSections,
  (sections): ConversationSidebarSectionConfig[] => {
    const order = ['my-convos', 'no-participants', 'all-convos']
    const list = Object.values(sections)
    return specifiedArraySort(list, order, 'type').filter((section) => {
      const isVisible = section.visible ?? true
      if (!isVisible) {
        return false
      }
      return section.type !== 'inbox'
    })
  }
)

export const currentUserNotificationsBySubscription = (
  state: RootState
): Record<string, SectionNotificationSetting> => {
  return root(state).currentUserNotificationsBySubscription ?? {}
}

export const getLoadingSubscriptions = (state: RootState): boolean =>
  root(state).conversationSectionsSubscriptionsStatus === FETCH_SECTIONS_SUBSCRIPTIONS_REQUEST

export const fetchConversationSectionsSubscriptionsFailed = (state: RootState): boolean =>
  root(state).conversationSectionsSubscriptionsStatus === FETCH_SECTIONS_SUBSCRIPTIONS_FAIL

export const fetchConversationSectionsFailed = (state: RootState): boolean =>
  root(state).conversationSectionsStatus === FETCH_SECTIONS_FAIL

export const getLoadingSections = (state: RootState): boolean =>
  root(state).conversationSectionsStatus === FETCH_SECTIONS_REQUEST

export const getConversationSidebarModalOpen = (state: RootState): boolean => {
  return root(state).sidebarSectionDetailModal.open
}

export const getConversationSidebarModal = (state: RootState): SidebarSectionDetailModal => {
  return root(state).sidebarSectionDetailModal
}
